import { Directive, Input, ElementRef, OnChanges, SimpleChanges, Renderer2, HostListener } from '@angular/core';
declare var bootstrap: any; // Bootstrap tooltip initialization

@Directive({
  selector: '[appTooltip]'
})
export class TooltipDirective implements OnChanges {

  @Input('appTooltip') tooltipTitle!: string;
  private tooltipInstance: any;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['tooltipTitle']) {
      this.updateTooltip();
    }
  }

  updateTooltip() {
    // Dispose old tooltip instance if it exists
    if (this.tooltipInstance) {
      this.tooltipInstance.dispose();
    }

    // Set new tooltip attributes
    this.renderer.setAttribute(this.el.nativeElement, 'data-bs-toggle', 'tooltip');
    this.renderer.setAttribute(this.el.nativeElement, 'title', this.tooltipTitle || '');

    // Initialize new tooltip
    this.tooltipInstance = new bootstrap.Tooltip(this.el.nativeElement);
  }

  // Ensure tooltip is shown on hover and not automatically
  @HostListener('mouseenter') onMouseEnter() {
    if (this.tooltipInstance) {
      this.tooltipInstance.show();
    }
  }

  @HostListener('mouseleave') onMouseLeave() {
    if (this.tooltipInstance) {
      this.tooltipInstance.hide();
    }
  }

  ngOnDestroy() {
    // Properly dispose the tooltip instance when the directive is destroyed
    if (this.tooltipInstance) {
      this.tooltipInstance.dispose();
    }
  }
}
